import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Homepage from './pages/Homepage';
import Promotions from './pages/Promotionpage';
import Products from './pages/Productpage';
import Portfolio from './pages/Porfoliopage';
import ProduceStep from './pages/ProduceStep';
import AdminDashboard from './pages/AdminDashboard';

import Navbar from './components/Navbar/navbar';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/products" element={<Products />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/produce-step" element={<ProduceStep />} />

        <Route path="/admin7749" element={<AdminDashboard />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;